import _ from 'lodash'
import validationList from '../Common/ProposalForm/Shared/validation/validationList'
import {
  validateSpec,
  validateProductSize,
  validatePreserveDays,
  validateProductGameContents,
  validateWarehouseProductName
} from '../Common/ProposalForm/Shared/validation/validations'
import { isEmptyStr } from '../../../lib/Validator'
import { isSkipRequired } from '../Common/ProposalForm/Shared/util'

const getFieldError = (fieldName, fieldValue, values) => {
  const validations = validationList[fieldName]
  const validationsLength = validations.length

  let fieldMsg
  for (let i = 0; i < validationsLength; i++) {
    const validation = validations[i]
    const localMsg = validation(fieldValue, values)
    if (localMsg) {
      fieldMsg = localMsg
      break
    }
  }

  return fieldMsg
}

export default values => {
  let errors = {}

  // 商品材積驗證
  errors = _.merge(errors, validateProductSize(values))

  // 保存期限驗證
  errors = _.merge(errors, validatePreserveDays(values))

  // 屬性設定驗證
  errors = _.merge(errors, validateSpec(values))

  // 電玩情節驗證
  errors = _.merge(errors, validateProductGameContents(values))

  // 進倉欄位驗證(warehouseProductName), 所有進倉欄位的內容不可重複
  errors = _.merge(errors, validateWarehouseProductName(values))

  // validate other fields which defined in validationList
  const skipRequired = isSkipRequired(values)
  for (const fieldName in validationList) {
    const fieldValue = _.get(values, fieldName, '')
    const hasValue = !isEmptyStr(fieldValue)

    const fieldError = (hasValue || !skipRequired)
      ? getFieldError(fieldName, fieldValue, values)
      : null

    _.set(
      errors,
      fieldName,
      fieldError
    )
  }

  return errors
}
